// The same top-level destinations are used on every public page.
// Detail pages belong in their directories, not in the main navigation.
const mainNavigationLinks = [
  ['/', 'Home'],
  ['/clients', 'Businesses'],
  ['/private-equity', 'Private Equity'],
  ['/services', 'Services'],
  ['/technologies', 'Technologies'],
  ['/our-company', 'Our Company'],
  ['/contact', 'Contact'],
];
const publicNavigationLinks = [...mainNavigationLinks, ['/login', 'Login']];
module.exports = { mainNavigationLinks, publicNavigationLinks };
